<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <div class="hidden md:col-span-1 md:block" />
            <div class="col-span-12 text-left md:col-span-10">
                <h2>Úvod</h2>
                <div class="mt-5 mb-5">
                    <img
                        src="../../public/img/titulni_obrazek.jpg"
                        alt=""
                        class="mb-1 h-96 w-full object-cover"
                    />
                    <span class="source"
                        >Historické označení ulice dochované na Novém Světě. /
                        Zdroj: Marek Lašťovka</span
                    >
                </div>
                <p class="mb-5 font-bold">
                    Ztrácíte se v pražských ulicích? Nejste sami.
                </p>
                <p class="mb-5 font-bold">
                    Jak vznikl Pražský uličník, jedinečná encyklopedie názvů
                    ulic, a proč bylo vhodné vytvořit jeho digitální verzi?
                    Přečtěte si příběh projektu, který pomáhá zorientovat se v
                    historii i současnosti pražských veřejných prostranství.
                </p>

                <p class="mb-5">
                    Pražský uličník. To je stručně řečeno encyklopedie názvů
                    pražských veřejných prostranství. Tedy ulic, náměstí,
                    nábřeží, mostů, parků, sadů a promenád.
                </p>

                <p class="mb-5">
                    Potřeba orientace ve stále se rozšiřujícím městě vedla už ke
                    konci 18. století k vydání prvních úředních seznamů
                    pražských veřejných prostranství. Skvělým přehledem se pak
                    stala příručka, kterou sepsal v roce 1870 Karel Jaromír
                    Erben a která byla tříděna podle jednotlivých pražských
                    čtvrtí a čísel popisných. Praha se ale rozrůstala dále, a
                    tak nutně vznikaly další seznamy ulic.
                </p>

                <p class="mb-5">
                    Poslední nový
                    <span class="italic">
                        Pražský uličník, encyklopedie názvů pražských veřejných
                        prostranství,</span
                    >
                    vyšel v roce 2022. Avšak poměrně rychle po vydání se stal z
                    hlediska seznamu ulic zastaralým, neboť nové názvy veřejných
                    prostranství jsou v Praze úředně schvalovány několikrát
                    ročně a jedná se o desítky názvů. A protože současná doba
                    vyžaduje také přístupnější formu než jen papírovou, tedy
                    digitální, vznikla tato webová aplikace, která nejenže
                    umožní rychlé vyhledávání jak v současných, tak i
                    historických názvech ulic, ale přináší zejména možnost
                    průběžné aktualizace, opravy nepřesností či doplňování nově
                    zjištěných údajů.
                </p>

                <p class="mb-5">
                    Ztotožnit stará místní určení se současnými, orientovat se v
                    ulicích, které opakovaně a často v rozmezí jednoho lidského
                    života změnily název, je složité. Současné tendence přitom
                    nijak nenaznačují, že by měl ustat trend přejmenovávání,
                    které je pravda někdy vynucováno dopravními a stavebními
                    změnami (přeložky ulic apod.), ale někdy politickými zásahy.
                    A zároveň s rozmachem a novou výstavbou města stále vznikají
                    a budou vznikat další nové komunikace, které musí být
                    pojmenovány.
                </p>

                <p class="mb-10 sm:mb-15">
                    Věříme, že tato aplikace pomůže všem jejím uživatelům vyznat
                    se lépe v pražském uličním názvosloví a přinese jim pohodlné
                    vyhledávání.
                </p>

                <p class="mb-25">Autoři a celý zpracovatelský tým</p>
            </div>
            <div class="hidden md:col-span-1 md:block" />
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
